import { numberToHex } from '../../utils/encoding/toHex.js';
export async function setMinGasPrice(client, { gasPrice }) {
    await client.request({
        method: `${client.mode}_setMinGasPrice`,
        params: [numberToHex(gasPrice)],
    });
}
//# sourceMappingURL=setMinGasPrice.js.map